'use strict';

import { hostFactory as hostInstance } from "@api/factory";

import { LoggerBus } from '@app/utils/logger-bus';
const loggerFormat = '[api::lessons]';

const preview = id =>{
  LoggerBus.$log.debug(loggerFormat);
  return hostInstance.get(`/api/lessons/${id}/preview`);
}

export default {
  preview
};